// import { REGEX } from 'consts';


const inputs = {
  search: {
    id: 'search',
    name: 'search',
    input: 'textField',
    label: 'common.components.search.label',
    placeholder: 'common.components.search.placeholder',
    position: 'vertical',
    rules: {}
  },
  project: {
    id: 'project',
    name: 'project',
    input: 'autocomplete',
    label: 'common.components.project.label',
    placeholder: 'common.components.project.placeholder',
    position: 'vertical',
    rules: {}
  }
}

export default inputs;
